module.exports = __webpack_public_path__ + "static/media/Swaziland.f4441c5c.png";